<template>
<div class="dashboard">
  <div class='row'>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <h2 class="card-title">Dashboard</h2>
          </div>
        </div>
        <div class="card-body" v-if="user !== null && comparacionRoles">
          <div class="position-relative">
            <div class="row">
              <div class="col-lg-3"><b>Flowline:</b></div>
              <div class="col-lg-4">
                <b-form-select v-model="selectedFlowline" :options="optionsFlowline" class="mb-3">
                  <template v-slot:first>
                    <option :value="null" disabled>-- Please select an option --</option>
                  </template>
                </b-form-select>
              </div>
              <div class="col-lg-2"><b>Año:</b></div>
              <div class="col-lg-3">
                <b-form-select v-model="selectedYear" :options="optionsYear" class="mb-3">
                  <template v-slot:first>
                    <option :value="null" disabled>-- Please select an option --</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="row">
              <!---------------------- TABLA DE RESALTADO ---------------------->
              <div class="col-lg-12">
                <div class="card-header">
                  <div class="d-flex justify-content-between">
                    <h3 class="card-title">IFRM REGISTRADO</h3>
                  </div>
                </div>
                <div class="card-body">
                  <div class="position-relative">
                    <b-table small :striped="true" :items="items" :fields="fields">
                      <template v-slot:cell()="data">
                        <template v-if="typeof data.value === 'object'">
                          <router-link
                            :to="{ name: $route.params.json + '_view', params: { typex: $route.params.typex, json: $route.params.json, id: data.value.id } }"
                            target="_blank" >
                            {{data.value.ifrm_value}}
                          </router-link>
                        </template>
                        <template v-else>{{ data.value }}</template>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
            <!---------------------- DOUGHNUT CHART ---------------------->
            <div class="col-lg-12">
              <div class="card-header">
                <div class="d-flex justify-content-between">
                  <h3 class="card-title">IFRM REGISTRADO</h3>
                </div>
              </div>
              <div class="card-body">
                <div class="position-relative">
                  <div class="row">
                    <div class="col-lg-8">
                      <doughnut-chart :chart-data="doughnutchartdata" :options="doughnutchartoptions" :height="100"></doughnut-chart>
                    </div>
                    <div class="col-lg-4">
                      <b-table small :striped="true" :items="doughnutchartSideTable" :fields="doughnutchartSideFields"></b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!---------------------- BAR CHART ---------------------->
            <div class="col-lg-12">
              <div class="card-header">
                <div class="d-flex justify-content-between">
                  <h3 class="card-title">CANTIDAD DE INSPECCIONES POR PROGRESIVA</h3>
                </div>
              </div>
              <div class="card-body">
                <div class="position-relative">
                  <bar-chart :chart-data="chartdata" :options="chartoptions" :height="100" :plugins="chartplugins"></bar-chart>
                </div>
              </div>
            </div>
            <!---------------------- LINE CHART ---------------------->
            <div class="col-lg-12">
              <div class="card-header">
                <div class="d-flex justify-content-between">
                  <h3 class="card-title">INSPECCIONES REGISTRADAS POR MESES</h3>
                </div>
              </div>
              <div class="card-body">
                <div class="position-relative">
                  <bar-chart :chart-data="linechartdata" :options="linechartoptions" :height="100" :plugins="chartplugins"></bar-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import Base from './Base.vue'
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
// import FormComponent from './FormComponents/FormComponent.vue'
import BarChart from './chart/BarChart.vue'
import DoughnutChart from './chart/DoughnutChart.vue'

export default {
  extends: Base,
  components: {
    BarChart,
    DoughnutChart /*,
    FormComponent */
  },
  name: 'dashboard',
  data () {
    return {
      pieChartData: [0, 0, 0, 0, 0],
      doughnutchartSideFields: [
        { key: '0', label: ' ' },
        { key: '1', label: 'Nivel' },
        { key: '2', label: 'Valor' },
        { key: '3', label: 'Porcentaje' }
      ],
      doughnutchartSideTable: [
        { '0': 'NIVEL 1', '1': 'Muy Bajo', 2: 0, '3': '0%' },
        { '0': 'NIVEL 2', '1': 'Bajo', '2': 0, '3': '0%' },
        { '0': 'NIVEL 3', '1': 'Moderado', '2': 0, '3': '0%' },
        { '0': 'NIVEL 4', '1': 'Moderadamente Alto', '2': 0, '3': '0%' },
        { '0': 'NIVEL 5', '1': 'Alto', '2': 0, '3': '0%' }
      ],
      pieChartStructure: {
        type: 'doughnut',
        data: {
          labels: ['muy bajo', 'bajo', 'moderado', 'moderadamente alto', 'alto'],
          datasets: [{
            label: 'progresivas',
            data: [],
            backgroundColor: [
              'rgba(255, 99, 132)',
              'rgba(54, 162, 235)',
              'rgba(255, 206, 86)',
              'rgba(75, 192, 192)',
              'rgba(153, 102, 255)'
            ],
            borderColor: [
              'rgba(255, 99, 132)',
              'rgba(54, 162, 235)',
              'rgba(255, 206, 86)',
              'rgba(75, 192, 192)',
              'rgba(153, 102, 255)'
            ]
          }]
        }
      },
      dashboardData: {},
      progressives: [],
      selectedFlowline: null,
      selectedYear: null,
      optionsFlowline: [],
      optionsYear: [],
      msg: 'Resumen de Inspecciones',
      doughnutchartdata: {
        labels: ['Muy bajo', 'Bajo', 'Moderado', 'Moderadamente Alto', 'Alto'],
        datasets: [
          {
            type: 'doughnut',
            data: [20, 20, 20, 20, 20]
          }
        ]
      },
      chartdata: {
        labels: [],
        datasets: [
          {
            backgroundColor: '#FFD792',
            data: []
          }
        ]
      },
      linechartdata: {
        labels: [],
        datasets: [
          {
            type: 'line',
            label: 'Linea límite',
            fill: false,
            showLine: true,
            pointRadius: 1,
            borderWidth: 4,
            borderColor: '#E8A9AA',
            data: []
          }
        ]
      },
      doughnutchartoptions: {
      },
      chartoptions: {
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Progresiva'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Cantidad'
            },
            ticks: {
              beginAtZero: true,
              stepSize: 2
            }
          }]
        },
        legend: {
          display: false
        },
        onClick: this.chartClick
      },
      linechartoptions: {
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Meses'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Cantidad'
            },
            ticks: {
              beginAtZero: true,
              stepSize: 2
            }
          }]
        },
        legend: {
          display: false
        },
        onClick: this.chartClick
      },
      chartplugins: [],
      items: [
      ],
      fields: [
        { key: 'number', label: 'N°', isRowHeader: true },
        { key: 'pk', label: 'PK' },
        { key: '0', label: 'ENE' },
        { key: '1', label: 'FEB' },
        { key: '2', label: 'MAR' },
        { key: '3', label: 'ABR' },
        { key: '4', label: 'MAY' },
        { key: '5', label: 'JUN' },
        { key: '6', label: 'JUL' },
        { key: '7', label: 'AGO' },
        { key: '8', label: 'SEP' },
        { key: '9', label: 'OCT' },
        { key: '10', label: 'NOV' },
        { key: '11', label: 'DIC' }
      ]
    }
  },
  watch: {
    metadata (to, from) {
      this.loadOptions()
    },
    selectedFlowline (to, from) {
      this.loadData()
    },
    selectedYear (to, from) {
      this.loadData()
    }
  },
  computed: {
    ...mapState([
      'user',
      'entities'
    ]),
    comparacionRoles () {
      if (!this.user.roles[0].startsWith('inspection_0') && !this.user.roles[0].startsWith('inspection_1')) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    loadOptions () {
      var flowlines = this.metadata.identification.choices[0].children.flowline.choices
      for (var option in flowlines) {
        this.optionsFlowline.push(
          {
            value: flowlines[option].value,
            text: flowlines[option].display_name
          }
        )
      }
      var currentYear = new Date().getFullYear()
      for (let i = 0; i < 10; i++) {
        this.optionsYear.push(currentYear - i)
      }
    },
    loadData () {
      let obj = this
      if (!obj.db) { return }
      if (obj.selectedFlowline != null && obj.selectedYear != null) {
        var startDate = new Date(obj.selectedYear, 0, 0)
        var finishDate = new Date(obj.selectedYear, 11, 31)
        this.dbconfig.get('config').then(function (config) {
          var url = obj.db.name + '/_design/app/_view/flowlinepks'
          Vue.http.get(url, {
            withCredentials: true,
            params: {
              reduce: true,
              group: true,
              inclusive_end: true,
              start_key: JSON.stringify([obj.selectedFlowline]),
              end_key: JSON.stringify([obj.selectedFlowline, {}])
            }
          }).then(
            function (msj) {
              obj.progressives = msj.body.rows
            },
            function (err) {
              console.log(err)
              if ('message' in err) {
                obj.msg = err.message
              } else {
                obj.msg = err.toString()
              }
              obj.setMessage('DashboardLote: ' + JSON.stringify(err))
            }
          )
        })
        obj.db.find({
          selector: {
            'identification.flowline': {
              '$eq': obj.selectedFlowline
            },
            'landslide.inspection_date': {
              '$gte': startDate,
              '$lte': finishDate
            }
          },
          fields: ['_id', 'identification', 'ifrm.ifrm_value', 'landslide.inspection_date', 'username'],
          sort: [{ 'identification.progressive': 'asc' }, { 'landslide.inspection_date': 'asc' }],
          limit: 5000
        }).then(response => {
          obj.dashboardData = response.docs
          obj.loadComponents()
        })
      }
    },
    tdClass (value, key, item) {
      if (typeof value === 'object') {
        value = value.ifrm_value
      }
      if (value) {
        if (value <= 10) {
          this.pieChartData[0] = this.pieChartData[0] + 1
          return 'muybajo'
        } else if (value <= 20) {
          this.pieChartData[1] = this.pieChartData[1] + 1
          return 'bajo'
        } else if (value <= 32) {
          this.pieChartData[2] = this.pieChartData[2] + 1
          return 'moderado'
        } else if (value <= 42) {
          this.pieChartData[3] = this.pieChartData[3] + 1
          return 'moderadamentealto'
        } else {
          this.pieChartData[4] = this.pieChartData[4] + 1
          return 'alto'
        }
      } return ''
    },
    loadComponents () {
      var obj = this
      obj.items = []
      this.pieChartData = [0, 0, 0, 0, 0]
      obj.fields = [
        { key: 'number', label: 'N°', isRowHeader: true },
        { key: 'pk', label: 'PK' },
        { key: '0', label: 'ENE', tdClass: obj.tdClass },
        { key: '1', label: 'FEB', tdClass: obj.tdClass },
        { key: '2', label: 'MAR', tdClass: obj.tdClass },
        { key: '3', label: 'ABR', tdClass: obj.tdClass },
        { key: '4', label: 'MAY', tdClass: obj.tdClass },
        { key: '5', label: 'JUN', tdClass: obj.tdClass },
        { key: '6', label: 'JUL', tdClass: obj.tdClass },
        { key: '7', label: 'AGO', tdClass: obj.tdClass },
        { key: '8', label: 'SEP', tdClass: obj.tdClass },
        { key: '9', label: 'OCT', tdClass: obj.tdClass },
        { key: '10', label: 'NOV', tdClass: obj.tdClass },
        { key: '11', label: 'DIC', tdClass: obj.tdClass }
      ]
      var labelsLineChart = [
        'ENE',
        'FEB',
        'MAR',
        'ABR',
        'MAY',
        'JUN',
        'JUL',
        'AGO',
        'SEP',
        'OCT',
        'NOV',
        'DIC'
      ]
      var dataLineChart = []
      var doubleInspection = []
      var barchartLabels = []
      var barchartData = []
      let counter = 0
      for (let i in obj.progressives) {
        obj.items.push({ 'number': parseInt(i) + 1, 'pk': obj.progressives[i].key[1], _cellVariants: { 'number': 'light' } })
        barchartLabels.push(obj.progressives[i].key[1])
        barchartData.push(0)
      }
      for (let i in obj.dashboardData) {
        this.tdClass(obj.dashboardData[i].ifrm.ifrm_value)
        let j = barchartLabels.findIndex(element => element === obj.dashboardData[i].identification.progressive)
        if (parseInt(i) === 0 || obj.dashboardData[i].identification.progressive !== obj.dashboardData[i - 1].identification.progressive) {
          if (j && counter !== 0) barchartData[j - 1] = counter
          counter = 1
        } else {
          counter++
          let currentMonth = new Date(obj.dashboardData[i].landslide.inspection_date).getUTCMonth()
          let lastMonth = new Date(obj.dashboardData[i - 1].landslide.inspection_date).getUTCMonth()
          if (currentMonth === lastMonth) {
            if (doubleInspection.includes(currentMonth) === false) {
              doubleInspection.push(currentMonth)
            }
          }
        }
        if (j && obj.dashboardData.length - i === 1) barchartData[j] = counter
      }
      let addcolumns = 0
      for (let i = 0; i <= 12; i++) {
        if (doubleInspection.includes(i)) {
          let newElement1 = { key: i + '_1', label: obj.fields[i + addcolumns + 2].label + ' 1ra', tdClass: obj.tdClass }
          let newElement2 = { key: i + '_2', label: obj.fields[i + addcolumns + 2].label + ' 2da', tdClass: obj.tdClass }
          let newLabel1 = labelsLineChart[i + addcolumns] + ' 1ra'
          let newLabel2 = labelsLineChart[i + addcolumns] + ' 2da'
          obj.fields.splice(i + addcolumns + 2, 1, newElement1, newElement2)
          labelsLineChart.splice(i + addcolumns, 1, newLabel1, newLabel2)
          addcolumns++
        }
      }
      for (let i in labelsLineChart) dataLineChart.push(i - i)
      for (let i in obj.dashboardData) {
        let theMonth = new Date(obj.dashboardData[i].landslide.inspection_date).getUTCMonth()
        let theDay = new Date(obj.dashboardData[i].landslide.inspection_date).getUTCDate()
        let found = obj.fields.find(element => element.key === theMonth.toString())
        let index = obj.fields.findIndex(element => element.key === theMonth.toString())
        let j = barchartLabels.findIndex(element => element === obj.dashboardData[i].identification.progressive)
        if (!found) {
          if (theDay <= 15) {
            index = obj.fields.findIndex(element => element.key === (theMonth + '_1'))
            obj.items[j][theMonth + '_1'] = {
              ifrm_value: obj.dashboardData[i].ifrm.ifrm_value,
              id: obj.dashboardData[i]._id
            }
          } else {
            obj.items[j][theMonth + '_2'] = {
              ifrm_value: obj.dashboardData[i].ifrm.ifrm_value,
              id: obj.dashboardData[i]._id
            }
            index = obj.fields.findIndex(element => element.key === (theMonth + '_2'))
          }
        } else {
          obj.items[j][theMonth] = {
            ifrm_value: obj.dashboardData[i].ifrm.ifrm_value,
            id: obj.dashboardData[i]._id
          }
        }
        dataLineChart[index - 2] = dataLineChart[index - 2] + 1
      }
      obj.$set(obj, 'chartdata', {
        labels: barchartLabels,
        datasets: [
          {
            label: 'CANTIDAD DE INSPECCIONES POR PROGRESIVA',
            backgroundColor: '#FFD792',
            data: barchartData
          }
        ]
      })
      let temp = [this.pieChartData[0], this.pieChartData[1], this.pieChartData[2], this.pieChartData[3], this.pieChartData[4]]
      obj.$set(obj, 'doughnutchartdata', {
        labels: ['Muy bajo', 'Bajo', 'Moderado', 'Moderadamente Alto', 'Alto'],
        datasets: [{
          type: 'doughnut',
          label: 'progresivas',
          data: temp,
          backgroundColor: [
            'rgba(0, 176, 80)',
            'rgba(146, 208, 80)',
            'rgba(255, 255, 0)',
            'rgba(255, 192, 0)',
            'rgba(255, 0, 0)'
          ],
          borderWidth: 1
        }]
      })
      let totalData = 0
      for (let i in obj.pieChartData) {
        totalData = obj.pieChartData[i] + totalData
      }
      let temp1 = (obj.pieChartData[0] / totalData) ? (obj.pieChartData[0] / totalData * 100).toFixed(2) : '0'
      let temp2 = (obj.pieChartData[1] / totalData) ? (obj.pieChartData[1] / totalData * 100).toFixed(2) : '0'
      let temp3 = (obj.pieChartData[2] / totalData) ? (obj.pieChartData[2] / totalData * 100).toFixed(2) : '0'
      let temp4 = (obj.pieChartData[3] / totalData) ? (obj.pieChartData[3] / totalData * 100).toFixed(2) : '0'
      let temp5 = (obj.pieChartData[4] / totalData) ? (obj.pieChartData[4] / totalData * 100).toFixed(2) : '0'
      obj.$set(obj, 'doughnutchartSideTable', [
        { '0': 'NIVEL 1', '1': 'Muy Bajo', '2': obj.pieChartData[0], '3': temp1 + '%' },
        { '0': 'NIVEL 2', '1': 'Bajo', '2': obj.pieChartData[1], '3': temp2 + '%' },
        { '0': 'NIVEL 3', '1': 'Moderado', '2': obj.pieChartData[2], '3': temp3 + '%' },
        { '0': 'NIVEL 4', '1': 'Moderadamente Alto', '2': obj.pieChartData[3], '3': temp4 + '%' },
        { '0': 'NIVEL 5', '1': 'Alto', '2': obj.pieChartData[4], '3': temp5 + '%' }
      ])
      obj.$set(obj, 'linechartdata', {
        labels: labelsLineChart,
        datasets: [
          {
            type: 'line',
            label: 'Linea límite',
            fill: false,
            showLine: true,
            pointRadius: 1,
            borderWidth: 4,
            borderColor: '#E8A9AA',
            data: dataLineChart
          }
        ]
      })
    },
    ...mapActions([
      'login',
      'logout',
      'init',
      'check_login'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .table td.muybajo{
    background-color: #00B050 !important;
    color: white !important;
  }
  .table td.muybajo a {
    color: white !important;
  }
  .table td.bajo{
    background-color: #92D050 !important;
  }
  .table td.bajo a {
    background-color: #92D050 !important;
    color: rgb(33, 37, 41) !important;
  }
  .table td.moderado{
    background-color: #FFFF00 !important;
  }
  .table td.moderado a {
    color: rgb(33, 37, 41) !important;
  }
  .table td.moderadamentealto{
    background-color: #FFBF00 !important;
  }
  .table td.moderadamentealto a {
    color: rgb(33, 37, 41) !important;
  }
  .table td.alto{
    background-color: #FF0000 !important;
    color: white !important;
  }
  .table td.alto a {
    color: white !important;
  }
</style>
